import ComponentElement from 'components/component-element';
import PriceSlider from 'components/price-slider';
import {formatMoney} from 'methods/utils';

function KurortPriceFilterComponent($element, options = {}) {
    ComponentElement.call(this, $element, options);

    this.$slider = this.$element.querySelector('.js-price-slider');
    this.slider = new PriceSlider(this.$slider, {
        useCandles: !this.options.isMobile,
        on: {
            change: (...values) => {
                this.emit('change', ...values);
            },
        },
    });
}

KurortPriceFilterComponent.prototype = Object.create(ComponentElement.prototype);
Object.defineProperty(KurortPriceFilterComponent.prototype, 'constructor', {
    value: KurortPriceFilterComponent,
    enumerable: false,
    writable: true,
});

KurortPriceFilterComponent.prototype.init = function () {
    //
}

KurortPriceFilterComponent.prototype.setStats = function (values) {
    this.slider.setStats(values);
}

KurortPriceFilterComponent.prototype.setBounds = function (min, max) {
    this.slider.setBounds(min, max);
}

KurortPriceFilterComponent.prototype.setValues = function (from, to) {
    this.slider.setValues(from, to);
}

KurortPriceFilterComponent.prototype.getValues = function () {
    return this.slider.getValues();
}

KurortPriceFilterComponent.prototype.getBounds = function () {
    return this.slider.getBounds();
}

KurortPriceFilterComponent.prototype.format = function (value) {
    return formatMoney(value, 0, '', ' ');
}

KurortPriceFilterComponent.prototype.reset = function () {
    this.slider.reset();
}

KurortPriceFilterComponent.prototype.resetFrom = function () {
    this.slider.resetFrom();
}

KurortPriceFilterComponent.prototype.resetTo = function () {
    this.slider.resetTo();
}

KurortPriceFilterComponent.prototype.isInit = function () {
    return true;
}

KurortPriceFilterComponent.prototype.isFromValueSelected = function () {
    return this.slider.isFromValueSelected();
}

KurortPriceFilterComponent.prototype.isToValueSelected = function () {
    return this.slider.isToValueSelected();
}

KurortPriceFilterComponent.prototype.isFromOrToValuesSelected = function () {
    return this.slider.isFromOrToValuesSelected();
}

KurortPriceFilterComponent.prototype.updatePriceTextPlaceholder = function (min, max) {
    return this.slider.updatePriceTextPlaceholder(min, max);
}

export default KurortPriceFilterComponent;
